import '../../../scss/critical.scss';
import '../../../scss/developer.scss';
import 'highlight.js/styles/monokai-sublime.css';

const $ = require('jquery');
global.$ = global.jQuery = $;

$(document).ready(function () {
    import(
        /* webpackMode: "eager" */
        '../qg-main'
    ).then(function () {});
});

import ClipboardJS from 'clipboard';
// only load support for xml, otherwise this will be 800 kb of minified code
import hljs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/xml';
hljs.registerLanguage('xml', javascript);

hljs.initHighlightingOnLoad();
var clipboard = new ClipboardJS('.clipboard-btn');

clipboard.on('success', function (e) {
    e.clearSelection();
});

clipboard.on('error', function (e) {});
